
export enum EFieldType {
  INPUT,
  FILE,
  TEXTAREA,
  CHECKBOX,
  RADIO,
  SELECT,
  DATE,
  MAIL,
  MONACO_HTML,
  SELECT_MULTIPLE,
  ORDONNABLE_SELECT_MULTIPLE,
  STRING_SELECT,
  DATE_TIME
}
